<!-- Admin banner -->
@if (currentUser()) {
  <div class="admin-banner">
    Modo Landing activo — estás viendo la página pública.
    <a routerLink="/dashboard">Ir al dashboard →</a>
  </div>
}

<!-- ── NAVBAR ──────────────────────────────────────────────────────── -->
<nav class="nav">
  <div class="nav-inner">
    <a href="#inicio" class="nav-logo" aria-label="TimeFlexRent">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 487.66 76"><defs><style>.cls-1{fill:#1b2e4f;}.cls-2{fill:#ffa600;}.cls-3{fill:#1b3053;}.cls-4{fill:#1b3153;}.cls-5{fill:#1a3051;}.cls-6{fill:#9ab2c1;}</style></defs><g><g><path class="cls-1" d="M103.46,100.44V65h-14v-6.6h35.74V65h-14v35.4Z" transform="translate(0 -40.31)"/><path class="cls-1" d="M131.8,63.12a4.77,4.77,0,0,1-3.46-1.32A4.36,4.36,0,0,1,127,58.56a4.22,4.22,0,0,1,1.35-3.12,4.77,4.77,0,0,1,3.46-1.32,4.93,4.93,0,0,1,3.46,1.23,4,4,0,0,1,1.36,3.15,4.47,4.47,0,0,1-1.33,3.27A4.66,4.66,0,0,1,131.8,63.12Zm-3.73,37.32v-32h7.46v32Z" transform="translate(0 -40.31)"/><path class="cls-1" d="M143.12,100.44v-32h7.16V77L149,74.4a11.38,11.38,0,0,1,4.73-4.74A14.7,14.7,0,0,1,160.81,68a13.73,13.73,0,0,1,7.82,2.22A10.81,10.81,0,0,1,173,77L170.13,76a12.44,12.44,0,0,1,5.12-5.76A15.63,15.63,0,0,1,183.61,68a15,15,0,0,1,6.83,1.5,10.73,10.73,0,0,1,4.67,4.62,16.74,16.74,0,0,1,1.68,8v18.36h-7.46V83q0-4.26-1.9-6.36a6.87,6.87,0,0,0-5.38-2.1,8.69,8.69,0,0,0-4.37,1.08,7.29,7.29,0,0,0-2.94,3.21,11.82,11.82,0,0,0-1.06,5.31v16.26h-7.46V83q0-4.26-1.89-6.36a6.9,6.9,0,0,0-5.39-2.1,8.65,8.65,0,0,0-4.36,1.08,7.26,7.26,0,0,0-3,3.21,12,12,0,0,0-1,5.31v16.26Z" transform="translate(0 -40.31)"/><path class="cls-1" d="M219.11,100.86a19.58,19.58,0,0,1-9.35-2.13,15.49,15.49,0,0,1-6.2-5.82,16.23,16.23,0,0,1-2.2-8.49,16.58,16.58,0,0,1,2.14-8.49,15.49,15.49,0,0,1,5.9-5.82A17.05,17.05,0,0,1,218,68a16.69,16.69,0,0,1,8.36,2.07,15,15,0,0,1,5.78,5.79,17.66,17.66,0,0,1,2.11,8.82q0,.42,0,1t-.09,1.11H207.32v-5h22.81l-3,1.56A9.32,9.32,0,0,0,226,78.57a8.31,8.31,0,0,0-3.22-3.3A9.5,9.5,0,0,0,218,74.1a9.9,9.9,0,0,0-4.84,1.17,7.92,7.92,0,0,0-3.28,3.33,10.4,10.4,0,0,0-1.15,5v1.2a9.87,9.87,0,0,0,1.3,5.1,8.77,8.77,0,0,0,3.7,3.45,12.12,12.12,0,0,0,5.59,1.23,12.63,12.63,0,0,0,4.88-.9A11.42,11.42,0,0,0,228,91l4.09,4.68a14.39,14.39,0,0,1-5.5,3.84A20,20,0,0,1,219.11,100.86Z" transform="translate(0 -40.31)"/><path class="cls-1" d="M239.75,100.44v-42H270.5V65H247.58v35.4ZM247,84.3V77.82h20.94V84.3Z" transform="translate(0 -40.31)"/><path class="cls-1" d="M275,100.44V55.92h7.47v44.52Z" transform="translate(0 -40.31)"/><path class="cls-1" d="M305.1,100.86a19.65,19.65,0,0,1-9.36-2.13,15.53,15.53,0,0,1-6.19-5.82,16.23,16.23,0,0,1-2.2-8.49,16.58,16.58,0,0,1,2.14-8.49,15.46,15.46,0,0,1,5.89-5.82A17.12,17.12,0,0,1,304,68a16.72,16.72,0,0,1,8.36,2.07,15,15,0,0,1,5.78,5.79,17.65,17.65,0,0,1,2.1,8.82q0,.42,0,1t-.09,1.11H293.31v-5h22.8l-3,1.56A9.42,9.42,0,0,0,312,78.57a8.38,8.38,0,0,0-3.22-3.3A9.52,9.52,0,0,0,304,74.1a9.94,9.94,0,0,0-4.85,1.17,8,8,0,0,0-3.28,3.33,10.51,10.51,0,0,0-1.14,5v1.2a10,10,0,0,0,1.29,5.1,8.85,8.85,0,0,0,3.71,3.45,12.09,12.09,0,0,0,5.59,1.23,12.63,12.63,0,0,0,4.88-.9A11.52,11.52,0,0,0,314,91l4.09,4.68a14.43,14.43,0,0,1-5.51,3.84A19.9,19.9,0,0,1,305.1,100.86Z" transform="translate(0 -40.31)"/><path class="cls-1" d="M319.72,100.44,333.8,82.08l-.06,4L320.2,68.4h8.43l9.45,12.54h-3.19l9.5-12.54h8.13l-13.6,17.7.06-4,14.14,18.36h-8.55l-9.92-13.38,3.18.42-9.74,13Z" transform="translate(0 -40.31)"/><path class="cls-1" d="M355.83,60.54a54.72,54.72,0,0,1,10.05-.84c5.59,0,9.21,1,11.73,3.3a10,10,0,0,1,3.19,7.68A10.62,10.62,0,0,1,373.16,81v.18c3.13,1.08,5,4,6,8.16,1.32,5.64,2.28,9.54,3.13,11.1h-5.42c-.66-1.14-1.56-4.62-2.71-9.66-1.2-5.58-3.37-7.68-8.12-7.86h-4.94v17.52h-5.23ZM361.06,79h5.36c5.6,0,9.15-3.06,9.15-7.68,0-5.22-3.79-7.5-9.33-7.56a21.68,21.68,0,0,0-5.18.48Z" transform="translate(0 -40.31)"/><path class="cls-1" d="M391.21,86.88C391.33,94,395.9,97,401.2,97a19.16,19.16,0,0,0,8.06-1.5l.91,3.78a23.69,23.69,0,0,1-9.69,1.8c-9,0-14.33-5.88-14.33-14.64s5.18-15.66,13.67-15.66c9.5,0,12,8.34,12,13.68a19.91,19.91,0,0,1-.18,2.46Zm15.53-3.78c.06-3.36-1.39-8.58-7.35-8.58-5.35,0-7.7,4.92-8.12,8.58Z" transform="translate(0 -40.31)"/><path class="cls-1" d="M418.41,79.26c0-3-.06-5.46-.24-7.86h4.69l.3,4.8h.12a10.73,10.73,0,0,1,9.63-5.46c4,0,10.29,2.4,10.29,12.36v17.34h-5.29V83.7c0-4.68-1.75-8.58-6.75-8.58A7.74,7.74,0,0,0,423.7,83v17.46h-5.29Z" transform="translate(0 -40.31)"/><path class="cls-1" d="M457.94,63.06V71.4h7.58v4h-7.58V91.08c0,3.6,1,5.64,4,5.64a11.77,11.77,0,0,0,3.07-.36l.24,4a13,13,0,0,1-4.69.72,7.36,7.36,0,0,1-5.72-2.22c-1.5-1.56-2-4.14-2-7.56V75.42h-4.52v-4h4.52v-7Z" transform="translate(0 -40.31)"/><path class="cls-2" d="M473.34,94.2c0-4.44,3-7.56,7.22-7.56s7.1,3.12,7.1,7.56-2.76,7.56-7.22,7.56C476.23,101.76,473.34,98.52,473.34,94.2Z" transform="translate(0 -40.31)"/><path class="cls-1" d="M36,56.45q12.25,0,24.49,0a8.19,8.19,0,0,1,5.76,2.11,7.75,7.75,0,0,1,2.29,3.83,7.51,7.51,0,0,1-1,6.32,7.87,7.87,0,0,1-5.93,3.64,32.31,32.31,0,0,1-3.55.07,1.23,1.23,0,0,0-.82.29c-1.44,1.19-2.9,2.37-4.36,3.54l-5.09,4c-.91.73-1.81,1.47-2.74,2.18A2.7,2.7,0,0,0,44,84.74q0,10.53,0,21.08c0,1.27,0,2.55,0,3.82A7.76,7.76,0,0,1,41.29,115a7.56,7.56,0,0,1-6.3,2,7.67,7.67,0,0,1-5.56-3.38A8,8,0,0,1,28,109c0-7.55,0-15.11,0-22.67a3,3,0,0,0-1.67-2.83c-1.89-1.11-3.73-2.31-5.6-3.47S16.91,77.65,15,76.48a6.51,6.51,0,0,1-2.91-3.61c-.11-.33-.25-.48-.63-.47a8.13,8.13,0,0,1-6.24-2.55,7.52,7.52,0,0,1-1.86-3.3,7.73,7.73,0,0,1-.18-3.41,7.85,7.85,0,0,1,3.74-5.53,8.87,8.87,0,0,1,4.8-1.17Z" transform="translate(0 -40.31)"/><path class="cls-3" d="M36,40.31a36.64,36.64,0,0,1,8.66,1.1A34.39,34.39,0,0,1,51.73,44,35,35,0,0,1,58,48a35.43,35.43,0,0,1,4.06,3.78c.62.69,1.2,1.42,1.8,2.13.1.12.21.27.12.4s-.25,0-.38,0a15.61,15.61,0,0,0-4.86-.48.63.63,0,0,1-.5-.19A31.78,31.78,0,0,0,43.89,45.6a39.9,39.9,0,0,0-4-.76,29.59,29.59,0,0,0-5.72-.19,31.21,31.21,0,0,0-10.78,2.53,32.59,32.59,0,0,0-7.17,4.25,30.26,30.26,0,0,0-2.55,2.24.62.62,0,0,1-.46.19,20.33,20.33,0,0,0-3.4.15c-.51.1-1,.23-1.53.35-.11,0-.21.09-.3,0s0-.22,0-.32a35.46,35.46,0,0,1,3.74-4.1,34,34,0,0,1,3.33-2.77,35.68,35.68,0,0,1,7-4A35.74,35.74,0,0,1,36,40.31Z" transform="translate(0 -40.31)"/><path class="cls-4" d="M70.78,67.88A37.54,37.54,0,0,1,71.88,78,36.17,36.17,0,0,1,71,84.51a34,34,0,0,1-1.59,5.24,35.68,35.68,0,0,1-2.9,5.84,37,37,0,0,1-6.13,7.58A37.14,37.14,0,0,1,47.65,111c-.51.2-1,.34-1.57.51-.36.11-.4.07-.37-.33s.07-.8.11-1.2c.08-.91,0-1.82,0-2.72a.38.38,0,0,1,.3-.43,31,31,0,0,0,8.3-4.22,32.12,32.12,0,0,0,11.25-14.4A29.65,29.65,0,0,0,67.44,82c.17-1,.3-2.09.39-3.14.11-1.36.06-2.72,0-4.08a9.5,9.5,0,0,0-.2-2.05.46.46,0,0,1,.14-.5,10.05,10.05,0,0,0,2.81-4A2.72,2.72,0,0,1,70.78,67.88Z" transform="translate(0 -40.31)"/><path class="cls-5" d="M26.05,108.81a17.16,17.16,0,0,0,.2,2.48c.05.27,0,.38-.33.28A35.08,35.08,0,0,1,21.6,110,36.68,36.68,0,0,1,8.15,99.51a37.44,37.44,0,0,1-5.77-10A34.7,34.7,0,0,1,.47,82.36a33.5,33.5,0,0,1-.28-9.11A42,42,0,0,1,1,68.4c0-.08,0-.21.14-.23s.16.11.19.18a10.14,10.14,0,0,0,2.72,3.84.47.47,0,0,1,.17.46A29.4,29.4,0,0,0,4,77.87,28.63,28.63,0,0,0,4.44,82a30.89,30.89,0,0,0,1.85,6.54,32.56,32.56,0,0,0,9,12.46,32.33,32.33,0,0,0,7.11,4.55,30.69,30.69,0,0,0,3.37,1.34c.2.07.28.15.27.36C26,107.77,26.05,108.29,26.05,108.81Z" transform="translate(0 -40.31)"/><path class="cls-6" d="M17.83,68.16a2.67,2.67,0,0,1,1.64.56l5.71,3.22,6.2,3.5a17.6,17.6,0,0,0,2.44,1.26,5,5,0,0,0,4.79-.58c1.7-1.14,3.26-2.48,4.88-3.74l3.39-2.65c1.86-1.45,3.72-2.92,5.57-4.38l5.29-4.14a4.22,4.22,0,0,1,1.54-1,2.21,2.21,0,0,1,2.25.74,2.55,2.55,0,0,1-.38,3.51c-1.47,1.14-2.88,2.36-4.33,3.53-2.79,2.25-5.53,4.55-8.34,6.77-1.71,1.35-3.38,2.74-5.07,4.11a13.36,13.36,0,0,0-1.8,1.55,4.88,4.88,0,0,0-1,2.35,4.55,4.55,0,0,1-2.84,3.47,4.66,4.66,0,0,1-6.25-3.1,3.2,3.2,0,0,0-1.53-2c-2.42-1.48-4.83-3-7.24-4.47l-5.26-3.25c-.36-.22-.71-.47-1.07-.69a2.56,2.56,0,0,1,.24-4.31A1.88,1.88,0,0,1,17.83,68.16Z" transform="translate(0 -40.31)"/></g></g></svg>
    </a>
    <div class="nav-right">
      <span class="badge-pill">Próximamente</span>
      <a href="#lista" class="btn-nav">Únete a la lista</a>
    </div>
  </div>
</nav>

<!-- ── HERO ────────────────────────────────────────────────────────── -->
<section class="hero" id="inicio">
  <div class="container hero-inner">
    <div class="hero-chip">
      <span class="chip-dot"></span>
      Lista de espera abierta
    </div>
    <h1>Tu espacio, tus reglas.<br><span class="gold">Monetiza cada hora.</span></h1>
    <p class="hero-sub">
      La plataforma española para alquilar espacios flexibles. Salas de fiestas,
      coworkings, estudios creativos y mucho más — sin complicaciones.
    </p>

    <div class="form-wrap" id="lista">
      @if (!heroSuccess()) {
        <form class="email-form" (ngSubmit)="submitHero()">
          <input type="email" placeholder="tu&#64;email.com" required autocomplete="email"
                 [(ngModel)]="heroEmail" name="heroEmail" />
          <button type="submit" class="btn-cta" [disabled]="heroLoading() || !heroConsent">
            {{ heroLoading() ? 'Guardando…' : 'Únete gratis' }}
          </button>
        </form>
        <div class="consent-row" style="max-width:520px;margin-left:auto;margin-right:auto">
          <input type="checkbox" id="consent-hero" [(ngModel)]="heroConsent" name="heroConsent" />
          <label for="consent-hero">
            He leído y acepto la
            <button type="button" class="link-legal" (click)="showPrivacy.set(true)">Política de Privacidad</button>.
            Consiento que TimeFlexRent use mi email para avisarme del lanzamiento.
          </label>
        </div>
        @if (heroError()) {
          <p class="form-error">{{ heroError() }}</p>
        }
        <p class="form-hint">Sin spam &middot; Sin compromiso &middot; Solo escribimos cuando abramos</p>
      } @else {
        <div class="form-success">✓ ¡Apuntado! Te avisaremos en cuanto abramos.</div>
      }
    </div>
  </div>
</section>

<!-- ── PROOF BAR ─────────────────────────────────────────────────── -->
<div class="proof-bar">
  <div class="container">
    <div class="proof-inner">
      <div class="proof-item">
        <div class="proof-num">100%</div>
        <div class="proof-label">Digital y sin papeleo</div>
      </div>
      <div class="proof-sep"></div>
      <div class="proof-item">
        <div class="proof-num">0 €</div>
        <div class="proof-label">Alta gratis para propietarios</div>
      </div>
      <div class="proof-sep"></div>
      <div class="proof-item">
        <div class="proof-num">24/7</div>
        <div class="proof-label">Reservas y pagos automáticos</div>
      </div>
    </div>
  </div>
</div>

<!-- ── PROPIETARIOS ──────────────────────────────────────────────── -->
<section class="section reveal" id="propietarios">
  <div class="container">
    <div class="split">
      <div class="split-text">
        <span class="section-tag">Para propietarios</span>
        <h2>Tu espacio trabaja para ti, incluso cuando no estás</h2>
        <p class="section-sub">Publica una vez, recibe reservas de forma automática. Sin llamadas, sin WhatsApps, sin gestión manual.</p>
        <div class="feat-list">
          <div class="feat-item">
            <div class="feat-icon feat-icon-blue">
              <svg width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>
            </div>
            <div class="feat-text">
              <h3>Publica en menos de 10 minutos</h3>
              <p>Wizard guiado paso a paso: descripción, fotos, calendario, precios y condiciones. Sin conocimientos técnicos.</p>
            </div>
          </div>
          <div class="feat-item">
            <div class="feat-icon feat-icon-blue">
              <svg width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
            </div>
            <div class="feat-text">
              <h3>Control total del calendario</h3>
              <p>Bloqueos recurrentes, períodos de temporada y festivos personalizados. Tu disponibilidad, a tu medida.</p>
            </div>
          </div>
          <div class="feat-item">
            <div class="feat-icon feat-icon-blue">
              <svg width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
            </div>
            <div class="feat-text">
              <h3>Cobros seguros y automáticos</h3>
              <p>Integración nativa con Stripe. El dinero llega a tu cuenta sin que tengas que perseguir a nadie.</p>
            </div>
          </div>
          <div class="feat-item">
            <div class="feat-icon feat-icon-blue">
              <svg width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>
            </div>
            <div class="feat-text">
              <h3>Panel de control completo</h3>
              <p>Ingresos, estadísticas, historial de reservas y facturas. Todo desde un único lugar, siempre actualizado.</p>
            </div>
          </div>
        </div>
      </div>
      <div class="split-visual">
        <div class="mock-card mock-card-dark">
          <p class="mock-label">Panel del propietario</p>
          <div class="stat-row">
            <div>
              <div class="stat-big">€ 3.840</div>
              <div class="stat-sub">Ingresos este mes</div>
            </div>
            <div style="text-align:right">
              <div class="stat-badge">+18%</div>
              <div class="stat-sub">vs mes anterior</div>
            </div>
          </div>
          <div class="bar-chart">
            <div class="bar" style="height:36%"></div>
            <div class="bar" style="height:54%"></div>
            <div class="bar" style="height:44%"></div>
            <div class="bar" style="height:72%"></div>
            <div class="bar" style="height:58%"></div>
            <div class="bar bar-hi" style="height:92%"></div>
            <div class="bar" style="height:76%"></div>
          </div>
          <p style="font-size:10px;color:rgba(255,255,255,.28);margin-top:8px;letter-spacing:.06em;text-transform:uppercase">Lun — Dom</p>
        </div>
        <div class="mock-card" style="margin-top:16px">
          <p class="mock-label">Reservas recientes</p>
          <div class="booking-row">
            <div class="booking-dot dot-green"></div>
            <div class="booking-info">
              <div class="booking-name">Sala Principal</div>
              <div class="booking-time">Hoy, 18:00 – 22:00</div>
            </div>
            <div class="booking-amt">€ 240</div>
          </div>
          <div class="booking-row">
            <div class="booking-dot dot-blue"></div>
            <div class="booking-info">
              <div class="booking-name">Sala B</div>
              <div class="booking-time">Mañana, 10:00 – 14:00</div>
            </div>
            <div class="booking-amt">€ 120</div>
          </div>
          <div class="booking-row">
            <div class="booking-dot dot-gold"></div>
            <div class="booking-info">
              <div class="booking-name">Sala Principal</div>
              <div class="booking-time">Sáb, 16:00 – 24:00</div>
            </div>
            <div class="booking-amt">€ 480</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ── INQUILINOS ────────────────────────────────────────────────── -->
<section class="section section-alt reveal" id="inquilinos">
  <div class="container">
    <div class="split split-rev">
      <div class="split-text">
        <span class="section-tag section-tag-gold">Para inquilinos</span>
        <h2>El espacio perfecto, en el momento exacto</h2>
        <p class="section-sub">Encuentra y reserva espacios únicos de forma instantánea y con total seguridad.</p>
        <div class="feat-list">
          <div class="feat-item">
            <div class="feat-icon feat-icon-gold">
              <svg width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            </div>
            <div class="feat-text">
              <h3>Encuentra el espacio perfecto</h3>
              <p>Filtra por tipo, ubicación, precio y disponibilidad real. Salas de fiestas, coworkings, estudios y mucho más.</p>
            </div>
          </div>
          <div class="feat-item">
            <div class="feat-icon feat-icon-gold">
              <svg width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
            </div>
            <div class="feat-text">
              <h3>Reserva al instante, sin llamadas</h3>
              <p>Elige fecha y hora, confirma online. Todo en menos de 2 minutos, sin intermediarios ni esperas.</p>
            </div>
          </div>
          <div class="feat-item">
            <div class="feat-icon feat-icon-gold">
              <svg width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>
            </div>
            <div class="feat-text">
              <h3>Pago seguro y confirmación inmediata</h3>
              <p>Paga con tarjeta de forma segura a través de Stripe. Confirmación por email al instante.</p>
            </div>
          </div>
        </div>
      </div>
      <div class="split-visual">
        <div class="mock-card">
          <div class="space-preview-img">
            <span style="font-size:52px">🎉</span>
            <div class="space-preview-price">€ 60<span style="font-size:14px;font-weight:500;color:#476788">/hora</span></div>
            <div class="space-preview-sub">Sala de fiestas · 150 m²</div>
          </div>
          <div style="margin-top:16px;display:flex;justify-content:space-between;align-items:center">
            <div>
              <div style="font-size:16px;font-weight:800;color:#0B3558">Sala Principal</div>
              <div style="font-size:12px;color:#476788;margin-top:2px">Hasta 80 personas</div>
            </div>
            <button class="btn-mock">Reservar</button>
          </div>
          <div style="margin-top:14px;display:flex;gap:8px;flex-wrap:wrap">
            <span class="tag-pill">Cocina equipada</span>
            <span class="tag-pill">Jardín</span>
            <span class="tag-pill">Parking</span>
            <span class="tag-pill">WiFi</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ── TIPOS DE ESPACIO ──────────────────────────────────────────── -->
<section class="section reveal" id="espacios">
  <div class="container" style="text-align:center">
    <span class="section-tag">Tipos de espacio</span>
    <h2 style="max-width:none;margin:0 auto 14px">Para cada ocasión, el espacio ideal</h2>
    <p class="section-sub" style="margin:0 auto 52px;max-width:560px">
      Desde íntimas reuniones de trabajo hasta grandes celebraciones. Encuentra exactamente lo que necesitas.
    </p>
    <div class="types-grid">
      <div class="type-card">
        <span class="type-emoji">🎉</span>
        <h3>Salas de fiestas</h3>
        <p>Cumpleaños, despedidas y celebraciones familiares en espacios equipados y únicos.</p>
      </div>
      <div class="type-card">
        <span class="type-emoji">💼</span>
        <h3>Coworking y reuniones</h3>
        <p>Salas bien equipadas para trabajo en equipo, formaciones y presentaciones de empresa.</p>
      </div>
      <div class="type-card">
        <span class="type-emoji">🎨</span>
        <h3>Estudios creativos</h3>
        <p>Espacios para fotografía, grabación, ensayo musical y producción artística.</p>
      </div>
      <div class="type-card">
        <span class="type-emoji">✨</span>
        <h3>Espacios únicos</h3>
        <p>Rooftops, lofts industriales, jardines privados y lugares que no encontrarás en otro sitio.</p>
      </div>
    </div>
  </div>
</section>

<!-- ── CÓMO FUNCIONA ─────────────────────────────────────────────── -->
<section class="section section-alt reveal" id="como-funciona">
  <div class="container">
    <div style="text-align:center">
      <span class="section-tag">Cómo funciona</span>
      <h2 style="max-width:none;margin:0 auto 12px">Tan sencillo como debe ser</h2>
      <p class="section-sub" style="margin:0 auto 40px;max-width:520px">
        En pocos pasos, tanto si publicas tu espacio como si buscas uno.
      </p>
    </div>
    <div class="tabs-row">
      <button class="tab-btn" [class.active]="activeTab() === 'owners'" (click)="activeTab.set('owners')">Soy propietario</button>
      <button class="tab-btn" [class.active]="activeTab() === 'renters'" (click)="activeTab.set('renters')">Busco un espacio</button>
    </div>
    <div class="steps-panel" [class.active]="activeTab() === 'owners'">
      <div class="step"><div class="step-num">1</div><h3>Publica tu espacio</h3><p>Rellena la información básica, sube fotos y configura tu calendario y precios. Todo guiado.</p></div>
      <div class="step"><div class="step-num">2</div><h3>Recibe reservas</h3><p>Los clientes reservan y pagan directamente. Tú recibes notificaciones y confirmas con un clic.</p></div>
      <div class="step"><div class="step-num">3</div><h3>Cobra automáticamente</h3><p>El dinero llega a tu cuenta de forma segura. Sin perseguir pagos, sin complicaciones.</p></div>
      <div class="step"><div class="step-num">4</div><h3>Crece con datos</h3><p>Accede a métricas, historial de reservas y facturas desde tu panel de control en cualquier momento.</p></div>
    </div>
    <div class="steps-panel" [class.active]="activeTab() === 'renters'">
      <div class="step"><div class="step-num">1</div><h3>Busca tu espacio</h3><p>Filtra por tipo, ubicación, precio y disponibilidad. Encuentra el lugar perfecto para tu evento.</p></div>
      <div class="step"><div class="step-num">2</div><h3>Elige fecha y hora</h3><p>Selecciona el horario que necesitas. Disponibilidad en tiempo real, sin tener que llamar a nadie.</p></div>
      <div class="step"><div class="step-num">3</div><h3>Reserva y paga online</h3><p>Confirma con tarjeta de forma segura a través de Stripe. Confirmación instantánea por email.</p></div>
      <div class="step"><div class="step-num">4</div><h3>Disfruta tu evento</h3><p>Llega, disfruta y listo. Tienes toda la información en tu confirmación. Sin sorpresas.</p></div>
    </div>
  </div>
</section>

<!-- ── CTA FINAL ─────────────────────────────────────────────────── -->
<section class="cta-final">
  <div class="container cta-inner">
    <h2>Sé el primero en<br><span>saberlo cuando abramos</span></h2>
    <p class="hero-sub">
      Lista de espera abierta. Te avisamos cuando TimeFlexRent esté disponible.
    </p>
    <div class="form-wrap">
      @if (!ctaSuccess()) {
        <form class="email-form" (ngSubmit)="submitCta()">
          <input type="email" placeholder="tu&#64;email.com" required autocomplete="email"
                 [(ngModel)]="ctaEmail" name="ctaEmail" />
          <button type="submit" class="btn-cta" [disabled]="ctaLoading() || !ctaConsent">
            {{ ctaLoading() ? 'Guardando…' : 'Apuntarme' }}
          </button>
        </form>
        <div class="consent-row" style="max-width:520px;margin-left:auto;margin-right:auto">
          <input type="checkbox" id="consent-cta" [(ngModel)]="ctaConsent" name="ctaConsent" />
          <label for="consent-cta">
            He leído y acepto la
            <button type="button" class="link-legal" (click)="showPrivacy.set(true)">Política de Privacidad</button>.
            Consiento que TimeFlexRent use mi email para avisarme del lanzamiento.
          </label>
        </div>
        @if (ctaError()) {
          <p class="form-error">{{ ctaError() }}</p>
        }
        <p class="form-hint">Sin spam &middot; Solo te contactamos cuando abramos</p>
      } @else {
        <div class="form-success">✓ ¡Perfecto! Ya estás en la lista.</div>
      }
    </div>
  </div>
</section>

<!-- ── FOOTER ────────────────────────────────────────────────────── -->
<footer>
  <div class="container">
    <div class="footer-inner">
      <a href="/" class="footer-logo" aria-label="TimeFlexRent">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 487.66 76" style="filter:brightness(0) invert(1) opacity(0.82)"><use href="#tfr-logo-path"/><g><g><path d="M103.46,100.44V65h-14v-6.6h35.74V65h-14v35.4Z" transform="translate(0 -40.31)" fill="rgba(255,255,255,.82)"/><path d="M36,56.45q12.25,0,24.49,0a8.19,8.19,0,0,1,5.76,2.11,7.75,7.75,0,0,1,2.29,3.83,7.51,7.51,0,0,1-1,6.32,7.87,7.87,0,0,1-5.93,3.64,32.31,32.31,0,0,1-3.55.07,1.23,1.23,0,0,0-.82.29c-1.44,1.19-2.9,2.37-4.36,3.54l-5.09,4c-.91.73-1.81,1.47-2.74,2.18A2.7,2.7,0,0,0,44,84.74q0,10.53,0,21.08c0,1.27,0,2.55,0,3.82A7.76,7.76,0,0,1,41.29,115a7.56,7.56,0,0,1-6.3,2,7.67,7.67,0,0,1-5.56-3.38A8,8,0,0,1,28,109c0-7.55,0-15.11,0-22.67a3,3,0,0,0-1.67-2.83c-1.89-1.11-3.73-2.31-5.6-3.47S16.91,77.65,15,76.48a6.51,6.51,0,0,1-2.91-3.61c-.11-.33-.25-.48-.63-.47a8.13,8.13,0,0,1-6.24-2.55,7.52,7.52,0,0,1-1.86-3.3,7.73,7.73,0,0,1-.18-3.41,7.85,7.85,0,0,1,3.74-5.53,8.87,8.87,0,0,1,4.8-1.17Z" transform="translate(0 -40.31)" fill="rgba(255,255,255,.82)"/></g></g></svg>
        <span style="font-size:18px;font-weight:800;color:rgba(255,255,255,.82);letter-spacing:-.01em">TimeFlexRent</span>
      </a>
      <div class="footer-links">
        <button type="button" class="link-legal" (click)="showPrivacy.set(true)" style="color:rgba(255,255,255,.38);font-size:13px">Privacidad</button>
        <a routerLink="/terminos" style="color:rgba(255,255,255,.38)">Términos</a>
        <a href="mailto:hola@timeflexrent.com" style="color:rgba(255,255,255,.38)">Contacto</a>
      </div>
      <span class="footer-copy">&copy; 2025 TimeFlexRent</span>
    </div>
  </div>
</footer>

<!-- Admin login link -->
<div class="admin-login-row">
  <a routerLink="/login">Acceso administrador</a>
</div>

<!-- ── PRIVACY MODAL ─────────────────────────────────────────────── -->
<div class="modal" [class.open]="showPrivacy()">
  <div class="modal-backdrop" (click)="showPrivacy.set(false)"></div>
  <div class="modal-panel">
    <div class="modal-header">
      <h2>Política de Privacidad</h2>
      <button class="modal-close" (click)="showPrivacy.set(false)" aria-label="Cerrar">&times;</button>
    </div>
    <div class="modal-body">
      <p>TimeFlexRent recopila tu dirección de email exclusivamente para informarte del lanzamiento de la plataforma.</p>
      <p>No compartimos tus datos con terceros ni los usamos para otros fines. Puedes solicitar la eliminación de tus datos en cualquier momento escribiendo a <a href="mailto:hola@timeflexrent.com">hola&#64;timeflexrent.com</a>.</p>
      <p>El responsable del tratamiento es TimeFlexRent. Base legal: consentimiento explícito (RGPD Art. 6.1.a).</p>
    </div>
  </div>
</div>

<!-- ── COOKIE BANNER ─────────────────────────────────────────────── -->
<div class="cookie-banner" [class.hidden]="!showCookie()">
  <div class="cookie-icon">🍪</div>
  <div class="cookie-text">
    Usamos cookies esenciales para el funcionamiento de la web.
    <button type="button" class="link-legal" (click)="showPrivacy.set(true)">Más info</button>
  </div>
  <div class="cookie-actions">
    <button class="cookie-btn cookie-btn-reject" (click)="rejectCookies()">Rechazar</button>
    <button class="cookie-btn cookie-btn-accept" (click)="acceptCookies()">Aceptar</button>
  </div>
</div>
